import Phaser from 'phaser';
import { GameScene } from '../GameScene';
import { TILE_SIZE } from '@shared/constants';

/**
 * Resaltado del tile del jugador (estilo Argentum): dibuja/actualiza el highlight del tile destino
 * local (updatePlayerTileHighlight), el del tile confirmado por el server (updateServerTileHighlight)
 * y refresca el highlight actual (refreshPlayerTileHighlight, p.ej. al togglear opciones). Extraído de
 * GameScene (god-object). Accede al scene vía `this.scene.*`.
 */
export class TileHighlightController {
  constructor(private scene: GameScene) {}

  public updatePlayerTileHighlight(tileX: number, tileY: number): void {
    if (!this.scene.showPlayerTile) {
      if (this.scene.playerTileGraphics) {
        this.scene.playerTileGraphics.clear();
      }

      return;
    }

    if (!this.scene.playerTileGraphics) {
      this.scene.playerTileGraphics = this.scene.add.graphics();
    }

    const gfx = this.scene.playerTileGraphics;

    gfx.clear();

    const worldX = tileX * TILE_SIZE;

    const worldY = tileY * TILE_SIZE;

    // Ligeramente más pequeño que el tile completo para que se vea un borde

    const padding = 2;

    const size = TILE_SIZE - padding * 2;

    gfx.lineStyle(2, 0x00ff00, 0.9);

    gfx.strokeRect(worldX + padding, worldY + padding, size, size);

    gfx.fillStyle(0x00ff00, 0.15);

    gfx.fillRect(worldX + padding, worldY + padding, size, size);

    // Profundidad: justo por debajo del personaje pero por encima del suelo.

    const baseDepth = this.scene.getEntityBaseDepthFromTileY(tileY);

    gfx.setDepth(baseDepth - 0.01);
  }

  /**
   * Dibuja el tile del servidor (rojo) para comparar con el tile del cliente (verde)
   */
  public updateServerTileHighlight(serverTileX: number, serverTileY: number): void {
    if (!this.scene.showPlayerTile) {
      if (this.scene.serverTileGraphics) {
        this.scene.serverTileGraphics.clear();
      }
      return;
    }

    if (!this.scene.serverTileGraphics) {
      this.scene.serverTileGraphics = this.scene.add.graphics();
    }

    const gfx = this.scene.serverTileGraphics;
    gfx.clear();

    const worldX = serverTileX * TILE_SIZE;
    const worldY = serverTileY * TILE_SIZE;

    const padding = 4;
    const size = TILE_SIZE - padding * 2;

    // Rojo para el tile del servidor
    gfx.lineStyle(2, 0xff0000, 0.9);
    gfx.strokeRect(worldX + padding, worldY + padding, size, size);
    gfx.fillStyle(0xff0000, 0.15);
    gfx.fillRect(worldX + padding, worldY + padding, size, size);

    const baseDepth = this.scene.getEntityBaseDepthFromTileY(serverTileY);
    gfx.setDepth(baseDepth - 0.02);
  }

  public refreshPlayerTileHighlight(): void {
    if (!this.scene.showPlayerTile) {
      if (this.scene.playerTileGraphics) {
        this.scene.playerTileGraphics.clear();
      }

      return;
    }

    if (!this.scene.localSessionId) return;

    const render = this.scene.playerObjects.get(this.scene.localSessionId);

    if (!render) return;

    // ESTILO ARGENTUM: Usar tile destino (lastTileX/Y)
    this.updatePlayerTileHighlight(render.lastTileX, render.lastTileY);
  }

}
